const formatChatTime = (timestamp) => {
    // 容错处理：处理字符串类型的时间戳，特别是修复缺少年份的日期格式
    let ts = timestamp;
    if (typeof timestamp === 'string') {
        // 修复类似 "-03-24T06:08:29.168Z" 这种缺少年份的格式
        if (timestamp.startsWith('-')) {
            const currentYear = new Date().getFullYear();
            ts = currentYear + timestamp;
        }
        ts = new Date(ts).getTime();
    }
    
    const now = new Date();
    const target = new Date(ts);

    // 如果日期无效，返回默认值
    if (isNaN(target.getTime())) {
        return { date: '-', time: '-' };
    }

    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const targetDate = new Date(target.getFullYear(), target.getMonth(), target.getDate());

    const timeDiff = today - targetDate;
    const oneDay = 24 * 60 * 60 * 1000;

    const timeStr = `${String(target.getHours()).padStart(2,"0")}:${String(target.getMinutes()).padStart(2,"0")}`;

    let date;
    if (timeDiff === 0) {
        date = timeStr;
    } else if (timeDiff === oneDay) {
        date = "昨天";
    } else if (target.getFullYear() === now.getFullYear()) {
        date = `${target.getMonth()+1}月${target.getDate()}日`;
    } else {
        date = `${target.getFullYear()}年${target.getMonth()+1}月${target.getDate()}日`;
    }

    return { date, time: timeStr };
};

export { formatChatTime }